"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableSwapFacet__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AssetLogic__handleIncomingAsset_feeOnTransferNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "AssetLogic__handleIncomingAsset_nativeAssetNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "AssetLogic__handleOutgoingAsset_notNative",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__getAdoptedAsset_assetNotFound",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__getApprovedCanonicalId_notAllowlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__nonReentrant_reentrantCall",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__nonXCallReentrant_reentrantCall",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrAdmin_notOwnerOrAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrRouter_notOwnerOrRouter",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrWatcher_notOwnerOrWatcher",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwner_notOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyProposed_notProposedOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__whenNotPaused_paused",
        type: "error",
    },
    {
        inputs: [],
        name: "StableSwapFacet__deadlineCheck_deadlineNotMet",
        type: "error",
    },
    {
        inputs: [],
        name: "StableSwapFacet__getSwapTokenBalance_indexOutOfRange",
        type: "error",
    },
    {
        inputs: [],
        name: "StableSwapFacet__getSwapTokenIndex_notExist",
        type: "error",
    },
    {
        inputs: [],
        name: "StableSwapFacet__getSwapToken_outOfRange",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenAmounts",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "fees",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "invariant",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokenSupply",
                type: "uint256",
            },
        ],
        name: "AddLiquidity",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAdminFee",
                type: "uint256",
            },
        ],
        name: "NewAdminFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSwapFee",
                type: "uint256",
            },
        ],
        name: "NewSwapFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenAmounts",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokenSupply",
                type: "uint256",
            },
        ],
        name: "RemoveLiquidity",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenAmounts",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "fees",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "invariant",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokenSupply",
                type: "uint256",
            },
        ],
        name: "RemoveLiquidityImbalance",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokenAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokenSupply",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "boughtId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensBought",
                type: "uint256",
            },
        ],
        name: "RemoveLiquidityOne",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "buyer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensSold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensBought",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "soldId",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "boughtId",
                type: "uint128",
            },
        ],
        name: "TokenSwap",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "minToMint",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "addSwapLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "calculateRemoveSwapLiquidity",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "tokenIndex",
                type: "uint8",
            },
        ],
        name: "calculateRemoveSwapLiquidityOneToken",
        outputs: [
            {
                internalType: "uint256",
                name: "availableTokenAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "tokenIndexFrom",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "tokenIndexTo",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "dx",
                type: "uint256",
            },
        ],
        name: "calculateSwap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "bool",
                name: "deposit",
                type: "bool",
            },
        ],
        name: "calculateSwapTokenAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "getSwapA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "getSwapAPrecise",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getSwapAdminBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "getSwapLPToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "getSwapStorage",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "key",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "initialA",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureA",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "initialATime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureATime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "swapFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adminFee",
                        type: "uint256",
                    },
                    {
                        internalType: "contract LPToken",
                        name: "lpToken",
                        type: "address",
                    },
                    {
                        internalType: "contract IERC20[]",
                        name: "pooledTokens",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenPrecisionMultipliers",
                        type: "uint256[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "balances",
                        type: "uint256[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "adminFees",
                        type: "uint256[]",
                    },
                    {
                        internalType: "bool",
                        name: "disabled",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "removeTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct SwapUtils.Swap",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "index",
                type: "uint8",
            },
        ],
        name: "getSwapToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "index",
                type: "uint8",
            },
        ],
        name: "getSwapTokenBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "getSwapTokenIndex",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "getSwapVirtualPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256[]",
                name: "minAmounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidity",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "maxBurnAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidityImbalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "tokenIndex",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "minAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidityOneToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "tokenIndexFrom",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "tokenIndexTo",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "dx",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minDy",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "assetIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "assetOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "minAmountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapExact",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "assetIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "assetOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maxAmountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapExactOut",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class StableSwapFacet__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StableSwapFacet__factory = StableSwapFacet__factory;
StableSwapFacet__factory.bytecode = _bytecode;
StableSwapFacet__factory.abi = _abi;
//# sourceMappingURL=StableSwapFacet__factory.js.map